define('core/utils/auth',[
    'core/utils/cookies',
], function (
    cookies
) {
    'use strict';

    // NOTE: getFromCookie is exported here to be used in both react and backbone applications.
    // For use in embed/home/next-core, it should be accessed via Session, not through auth.

    var exports = {};
    var DISQUS_AUTH_COOKIE = 'disqusauth';

    /**
     * Get user attributes from `disqusauth` cookie.
     * @returns {Object} Dictionary of user attributes.
     */
    exports.getFromCookie = function () {
        var auth = (cookies.read(DISQUS_AUTH_COOKIE) || '').replace(/"/g, '').split('|');

        // If we do have an auth cookie but not a username and id
        // then the auth cookie is corrupted in some way and we should
        // erase it.
        if (auth && !(auth[1] && auth[6])) {
            auth = [];
            cookies.erase(DISQUS_AUTH_COOKIE, {});
        }

        var id = parseInt(auth[6] || '0', 10);

        return {
            avatarUrl: auth[7] ? decodeURIComponent(auth[7]) : undefined,
            datetimeFormatting: parseInt(auth[4], 10) ? 'absolute' : 'relative',
            id: id,
            isModerator: parseInt(auth[8], 10) > 0,
            staff: Boolean(parseInt(auth[2], 10)),
            tzOffset: auth[5],
            username: auth[1],
            isAuthenticated: Boolean(id && id !== '0'),
        };
    };

    return exports;
});

